import React from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';

import * as modes from '~/modules/modal/modes';
import {modalChange} from '~/modules/modal/actions';
import mapDispatch from '~/misc/mapDispatch';

import sharedCSS from '~/components/shared.css';
import css from './index.css';

const ResetPasswordOk = ({login}) => (
  <div>
    <span className='qa-resetPassword'>Please check your email for password reset instructions</span>
    <div className={css.invitationOnReset}>
      <span className={cs(sharedCSS.a, 'qa-login-link')} onClick={login}>Login</span>
    </div>
  </div>
);

export default connect(null, mapDispatch({
  login: () => modalChange(modes.LOGIN, true),
}))(ResetPasswordOk);



// WEBPACK FOOTER //
// ./src/components/user/ResetPasswordOk/index.js